import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center px-6">
        <h1 className="font-display font-bold text-6xl text-white mb-4">404</h1>
        <p className="text-geminii-muted text-lg mb-8">This page doesn't exist.</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/[0.12] text-white font-medium text-sm hover:border-rogue-cyan/50 hover:text-rogue-cyan transition-all"
        >
          <ArrowLeft size={16} />
          Back to home
        </Link>
      </div>
    </div>
  );
}
